'use strict';

var _classCallCheck = require("/Users/anshaal/my-voice/my-voice-landing-page/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/Users/anshaal/my-voice/my-voice-landing-page/node_modules/@babel/runtime/helpers/createClass.js");

var _inherits = require("/Users/anshaal/my-voice/my-voice-landing-page/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/Users/anshaal/my-voice/my-voice-landing-page/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/Users/anshaal/my-voice/my-voice-landing-page/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var React = _interopDefault(require('react'));

var CrossFadeImage = /*#__PURE__*/function (_React$Component) {
  _inherits(CrossFadeImage, _React$Component);

  var _super = _createSuper(CrossFadeImage);

  function CrossFadeImage(props) {
    var _this;

    _classCallCheck(this, CrossFadeImage);

    _this = _super.call(this, props);
    _this.state = {
      bottomOpacity: 0,
      bottomSrc: props.src,
      topSrc: props.src
    };
    return _this;
  }

  _createClass(CrossFadeImage, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;

      if (prevProps.src !== this.props.src) {
        this.setState({
          bottomSrc: "",
          topSrc: ""
        }, function () {
          return _this2.setState({
            bottomSrc: prevProps.src,
            topSrc: _this2.props.src,
            bottomOpacity: 0.99
          }, function () {// if (!this.timeout) {
            //     clearTimeout(this.timeout);
            // }
          });
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          duration = _this$props.duration,
          timingFunction = _this$props.timingFunction,
          delay = _this$props.delay,
          style = _this$props.style,
          alt = _this$props.alt,
          className = _this$props.className;
      var _this$state = this.state,
          topSrc = _this$state.topSrc,
          bottomOpacity = _this$state.bottomOpacity,
          bottomSrc = _this$state.bottomSrc;
      return React.createElement("div", {
        style: {
          maxWidth: "100%",
          maxHeight: "100%"
        },
        className: className
      }, topSrc && React.createElement("img", {
        style: Object.assign({
          maxWidth: "100%",
          maxHeight: "100%",
          position: "absolute"
        }, style),
        src: topSrc,
        alt: alt
      }), bottomSrc && React.createElement("img", {
        style: Object.assign({
          maxHeight: "100%",
          maxWidth: "100%",
          opacity: bottomOpacity,
          transition: "opacity ".concat(duration / 1000, "s ").concat(timingFunction, " ").concat(delay / 1000, "s")
        }, style),
        src: bottomSrc
      }));
    }
  }, {
    key: "timeout",
    value: function timeout() {
      var _this3 = this;

      setTimeout(function () {
        return _this3.setState({
          bottomOpacity: 0
        });
      }, 20);
    }
  }]);

  return CrossFadeImage;
}(React.Component);

CrossFadeImage.defaultProps = {
  delay: 0,
  duration: 500,
  timingFunction: "ease"
};
module.exports = CrossFadeImage;